let storeImpl = null;
let clientStorePromise = null;

const loadClientStore = () => {
  if (!clientStorePromise) {
    clientStorePromise = import('./taskDataStore.client.js').then((m) => m.default);
  }
  return clientStorePromise;
};

const getStore = async () => {
  if (storeImpl) return storeImpl;
  storeImpl = await loadClientStore();
  return storeImpl;
};

export const configureTaskDataStore = (impl) => {
  storeImpl = impl;
};

export const resetTaskDataStore = () => {
  storeImpl = null;
};

const taskDataStore = {
  getAll: async (...args) => (await getStore()).getAll(...args),
  getById: async (...args) => (await getStore()).getById(...args),
  add: async (...args) => (await getStore()).add(...args),
  update: async (...args) => (await getStore()).update(...args),
  delete: async (...args) => (await getStore()).delete(...args),
};

export default taskDataStore;
